import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject } from '@angular/core';
import { AttachmentsActions } from './attachments.store';
import { map } from 'rxjs/operators';
import { FilesHelper } from '../../../../files/helpers/files.helper';

export const attachmentLoadedEffect = createEffect(
  () => {
    return inject(Actions).pipe(
      ofType(AttachmentsActions.loaded),
      map(({ attachment }) => {
        const blob = attachment.data
          ? FilesHelper.base64ToBlob(attachment.data)
          : null;
        return AttachmentsActions.updateOne({
          attachment: {
            id: attachment.id,
            changes: {
              ...attachment,
              blob,
            },
          },
        });
      })
    );
  },
  { functional: true }
);

